































import { mapActions } from 'vuex'
import { navigateTo } from '@/router'
import PublicPageContent from '@/components/PublicPageContent.vue'
import { isWronglyFormattedEmail } from '../email-validations'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'
import WithThemeTitle from '@/components/WithThemeTitle.vue'

export default {
  components: {
    WithThemeTitle,
    PublicPageContent
  },
  data() {
    return {
      email: '',
      emailFieldValidations: [
        {
          isInvalid: emailAddress => !emailAddress,
          errorMessage: this.$t('auth.forgotPassword.validation.emailIsRequired')
        },
        {
          isInvalid: isWronglyFormattedEmail,
          errorMessage: this.$t('auth.forgotPassword.validation.wrongFormat')
        }
      ]
    }
  },
  computed: {
    isPosteTheme() {
      return isPosteTheme
    }
  },
  methods: {
    ...mapActions(['sendForgottenPasswordLinkEmail']),
    async sendEmail(event) {
      if (event.hasErrors) return
      await this.sendForgottenPasswordLinkEmail(this.email)
      navigateTo('/auth/email-sent')
    }
  }
}
